export function resolveImageUrl(record, fallback = '') {
  if (!record || typeof record !== 'object') return fallback;

  return (
    record.imageUrl ||
    record.image ||
    record.thumbnailUrl ||
    record.thumbnail ||
    record.coverImageUrl ||
    record.coverImage ||
    fallback
  );
}

export function resolveProjectCoverUrl(project, fallback = '') {
  return resolveImageUrl(project, fallback);
}
